{
  "list": {
    "title": "Empresas",
    "description": "Empresas cliente de Fermin. Crea una nueva y entrega su enlace de configuración.",
    "new": "Nueva empresa",
    "search": "Buscar por nombre",
    "searchPlaceholder": "Nombre comercial o razón social",
    "filterStatus": "Estado",
    "all": "Todas",
    "empty": "Todavía no hay empresas",
    "emptyDescription": "Crea la primera empresa cliente para empezar a operar.",
    "loadMore": "Cargar más",
    "count": "{count} empresas"
  },
  "columns": {
    "tradeName": "Nombre comercial",
    "legalName": "Razón social",
    "taxId": "Identificador fiscal",
    "country": "País",
    "timezone": "Zona horaria",
    "status": "Estado",
    "sites": "Sedes",
    "admins": "Administradores",
    "createdAt": "Creada",
    "suspendedAt": "Suspendida el"
  },
  "status": {
    "ACTIVE": "Activa",
    "SUSPENDED": "Suspendida"
  },
  "form": {
    "createTitle": "Nueva empresa",
    "createDescription": "Registra la empresa y su primer administrador. Al guardar verás el enlace de configuración de contraseña.",
    "editTitle": "Editar empresa",
    "legalName": "Razón social",
    "legalNameHelp": "Nombre legal completo, tal como figura en el registro.",
    "tradeName": "Nombre comercial",
    "tradeNameHelp": "Es el nombre que se muestra en el panel y en los banners.",
    "taxId": "Identificador fiscal",
    "taxIdHelp": "RUC, RUT, NIT o equivalente. Único por país.",
    "country": "País",
    "countryPlaceholder": "Elige un país",
    "timezone": "Zona horaria por defecto",
    "timezonePlaceholder": "Elige una zona horaria",
    "timezoneHelp": "Las sedes nuevas la usan salvo que indiques otra.",
    "firstAdmin": "Primer administrador",
    "firstAdminHelp": "Recibe el rol Administrador de empresa y el enlace para definir su contraseña.",
    "adminName": "Nombre",
    "adminEmail": "Correo",
    "adminEmailHelp": "El correo es único en todo Fermin.",
    "submit": "Crear empresa",
    "saveChanges": "Guardar cambios",
    "errors": {
      "required": "Este campo es obligatorio.",
      "legalName": "Usa entre 2 y 200 caracteres.",
      "tradeName": "Usa entre 1 y 120 caracteres.",
      "taxId": "Usa entre 5 y 32 caracteres.",
      "country": "Elige un país de la lista.",
      "timezone": "Elige una zona horaria de la lista.",
      "adminName": "Usa entre 1 y 120 caracteres.",
      "adminEmail": "Escribe un correo válido.",
      "taxIdConflict": "Ya existe una empresa con ese identificador fiscal en ese país.",
      "emailConflict": "Ese correo ya está en uso por otro administrador.",
      "timezoneInvalid": "La zona horaria no es válida."
    }
  },
  "setupLink": {
    "title": "Enlace de configuración de contraseña",
    "description": "Entrégaselo a {name} por un canal seguro. No se volverá a mostrar.",
    "warning": "Este enlace se muestra una sola vez. Cópialo antes de cerrar.",
    "expires": "Vence el {date}",
    "copy": "Copiar enlace",
    "copied": "Enlace copiado",
    "done": "Listo"
  },
  "detail": {
    "back": "Volver a Empresas",
    "dataTitle": "Datos de la empresa",
    "adminsTitle": "Administradores",
    "adminsEmpty": "Esta empresa aún no tiene administradores.",
    "regenerate": "Regenerar enlace",
    "regenerateHelp": "Disponible mientras el administrador no haya definido su contraseña.",
    "supportSession": "Entrar como soporte",
    "supportSessionHelp": "Abre una sesión acotada a esta empresa. Todo el acceso queda auditado.",
    "hasPassword": "Con contraseña",
    "pendingPassword": "Pendiente de contraseña",
    "notFound": "No encontramos esta empresa.",
    "suspend": "Suspender",
    "reactivate": "Reactivar",
    "suspendedNotice": "La empresa está suspendida: sus administradores solo pueden consultar."
  },
  "admins": {
    "name": "Nombre",
    "email": "Correo",
    "role": "Rol",
    "status": "Estado",
    "password": "Contraseña",
    "scope": "Alcance"
  },
  "roles": {
    "SUPER_ADMIN": "Super Admin",
    "COMPANY_ADMIN": "Administrador de empresa",
    "SITE_MANAGER": "Encargado de sede",
    "VIEWER": "Solo lectura"
  },
  "toast": {
    "created": "Empresa creada",
    "updated": "Empresa actualizada",
    "linkReissued": "Enlace regenerado",
    "suspended": "Empresa suspendida",
    "reactivated": "Empresa reactivada"
  },
  "suspend": {
    "title": "Suspender {company}",
    "description": "Sus administradores pasarán a modo solo lectura y se cerrarán sus sesiones abiertas.",
    "reason": "Motivo",
    "reasonHelp": "Queda registrado en la auditoría. Máximo 500 caracteres.",
    "reasonRequired": "Escribe el motivo de la suspensión.",
    "confirm": "Suspender empresa"
  }
}
